export function initAccordionSupport() {
  const supportAccordions = document.querySelectorAll('.accordion-support');

  supportAccordions.forEach(function(accordion) {
    const accordionItems = accordion.querySelectorAll('.accordion__item-support');

    accordionItems.forEach(function(item) {
      item.addEventListener('click', function() {
        const previouslyActiveItems = accordion.querySelectorAll('.accordion__item-support.active');
        const previousContents = Array.from(previouslyActiveItems).map(function(activeItem) {
          return activeItem.querySelector('.accordion__content-support');
        }).filter(Boolean);

        // Toggle active class on clicked item
        const isActive = item.classList.contains('active');

        // Remove active class from all items in this accordion
        accordionItems.forEach(function(accordionItem) {
          accordionItem.classList.remove('active');
        });

        // If item wasn't active, make it active
        if (!isActive) {
          item.classList.add('active');
        }

        const adminBar = document.getElementById('wpadminbar');
        const adminOffset = adminBar ? adminBar.offsetHeight : 0;
        const stickyHeader = document.querySelector('.site-header.is-sticky, .site-header.sticky, header.sticky, header.is-sticky, .header.sticky, .header.is-sticky, header.wp-block-template-part');
        const stickyOffset = stickyHeader ? stickyHeader.offsetHeight : 0;
        const totalOffset = adminOffset + stickyOffset;

        const clickedContent = item.querySelector('.accordion__content-support');
        const contentsToObserve = Array.from(new Set([].concat(previousContents, clickedContent ? [clickedContent] : [])));

        function parseTimeToMs(value) {
          if (!value) return 0;
          return value.trim().split(',').reduce(function(maxMs, part) {
            const v = part.trim();
            if (!v) return maxMs;
            if (v.endsWith('ms')) {
              const ms = parseFloat(v);
              return Math.max(maxMs, isNaN(ms) ? 0 : ms);
            }
            if (v.endsWith('s')) {
              const ms = parseFloat(v) * 1000;
              return Math.max(maxMs, isNaN(ms) ? 0 : ms);
            }
            return maxMs;
          }, 0);
        }

        function getTransitionWaitMs(element) {
          if (!element) return 0;
          const styles = window.getComputedStyle(element);
          const durationMs = parseTimeToMs(styles.transitionDuration);
          const delayMs = parseTimeToMs(styles.transitionDelay);
          return durationMs + delayMs;
        }

        const waitMs = contentsToObserve.reduce(function(maxMs, el) {
          return Math.max(maxMs, getTransitionWaitMs(el));
        }, 0);

        const effectiveWait = Math.max(0, Math.min(1200, waitMs || 0)) + 20;

        setTimeout(function() {
          const top = item.getBoundingClientRect().top + window.pageYOffset - totalOffset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }, effectiveWait);
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  initAccordionSupport();
});
